/**
 * Usage:
 * <mable-clean-slate-container>
 *   <div class="slate-top"></div>
 *   <elem class="clean-slate"></elem>
 *   <elem class="slate-bottom"></elem>
 * </mable-clean-slate-container>
 */

import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  standalone: true,
  imports: [IonicModule, CommonModule],
  selector: 'mable-clean-slate-container',
  templateUrl: './clean-slate-container.component.html',
  styleUrls: ['./clean-slate-container.component.scss'],
})
export class CleanSlateContainerComponent {
  @ViewChild('cleanSlateElem', { read: ElementRef, static: true })
  cleanSlateElem: ElementRef;

  @Input() classes = '';

  hasCleanSlate() {
    return !!this.cleanSlateElem.nativeElement.childElementCount;
  }
}
